var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoundary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Boundary-st0{fill:none;}\r\n\t.Boundary-st1{fill:none;stroke:currentColor;stroke-linecap:square;}\r\n\t.Boundary-st2{fill:url(#pattern);}\r\n")), /*#__PURE__*/React.createElement("pattern", {
    x: -38,
    y: 74.5,
    width: 85,
    height: 85,
    patternUnits: "userSpaceOnUse",
    id: "pattern",
    viewBox: "50.1 -136.3 85 85",
    style: {
      overflow: "visible"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 50.1,
    y: -136.3,
    className: "Boundary-st0",
    width: 85,
    height: 85
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 134.7,
    y1: -0.7,
    x2: 185.6,
    y2: -51.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 132.3,
    y1: -3.1,
    x2: 183.2,
    y2: -54
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 129.9,
    y1: -5.5,
    x2: 180.8,
    y2: -56.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 127.5,
    y1: -7.9,
    x2: 178.4,
    y2: -58.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 49.7,
    y1: -0.7,
    x2: 100.6,
    y2: -51.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 47.3,
    y1: -3.1,
    x2: 98.2,
    y2: -54
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 44.9,
    y1: -5.5,
    x2: 95.8,
    y2: -56.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 42.5,
    y1: -7.9,
    x2: 93.4,
    y2: -58.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 134.7,
    y1: -85.7,
    x2: 185.6,
    y2: -136.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 132.3,
    y1: -88.2,
    x2: 183.2,
    y2: -139.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 129.9,
    y1: -90.6,
    x2: 180.8,
    y2: -141.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 127.5,
    y1: -93,
    x2: 178.4,
    y2: -143.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 93,
    y1: -42.5,
    x2: 143.9,
    y2: -93.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 90.6,
    y1: -44.9,
    x2: 141.5,
    y2: -95.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 88.2,
    y1: -47.3,
    x2: 139.1,
    y2: -98.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 85.7,
    y1: -49.7,
    x2: 136.7,
    y2: -100.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 83.3,
    y1: -52.1,
    x2: 134.3,
    y2: -103
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 80.9,
    y1: -54.5,
    x2: 131.8,
    y2: -105.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 78.5,
    y1: -56.9,
    x2: 129.4,
    y2: -107.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 76.1,
    y1: -59.3,
    x2: 127,
    y2: -110.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 73.7,
    y1: -61.7,
    x2: 124.6,
    y2: -112.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 71.3,
    y1: -64.1,
    x2: 122.2,
    y2: -115
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 68.9,
    y1: -66.5,
    x2: 119.8,
    y2: -117.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 66.5,
    y1: -68.9,
    x2: 117.4,
    y2: -119.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 64.1,
    y1: -71.3,
    x2: 115,
    y2: -122.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 61.7,
    y1: -73.7,
    x2: 112.6,
    y2: -124.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 59.3,
    y1: -76.1,
    x2: 110.2,
    y2: -127
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 56.9,
    y1: -78.5,
    x2: 107.8,
    y2: -129.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 54.5,
    y1: -80.9,
    x2: 105.4,
    y2: -131.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 52.1,
    y1: -83.3,
    x2: 103,
    y2: -134.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 49.7,
    y1: -85.7,
    x2: 100.6,
    y2: -136.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 47.3,
    y1: -88.2,
    x2: 98.2,
    y2: -139.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 44.9,
    y1: -90.6,
    x2: 95.8,
    y2: -141.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 42.5,
    y1: -93,
    x2: 93.4,
    y2: -143.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 7.9,
    y1: -42.5,
    x2: 58.8,
    y2: -93.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 5.5,
    y1: -44.9,
    x2: 56.4,
    y2: -95.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 3.1,
    y1: -47.3,
    x2: 54,
    y2: -98.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 0.7,
    y1: -49.7,
    x2: 51.6,
    y2: -100.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 93,
    y1: -127.5,
    x2: 143.9,
    y2: -178.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 90.6,
    y1: -129.9,
    x2: 141.5,
    y2: -180.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 88.2,
    y1: -132.3,
    x2: 139.1,
    y2: -183.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 85.7,
    y1: -134.7,
    x2: 136.7,
    y2: -185.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 7.9,
    y1: -127.5,
    x2: 58.8,
    y2: -178.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 5.5,
    y1: -129.9,
    x2: 56.4,
    y2: -180.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 3.1,
    y1: -132.3,
    x2: 54,
    y2: -183.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "Boundary-st1",
    x1: 0.7,
    y1: -134.7,
    x2: 51.6,
    y2: -185.6
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Boundary-st2",
    d: "M25.8,19.9c-1.6-1.4-2-1.6-3-2.9c-0.4-0.3,0.7,0,0.5-0.6c-0.4-0.3-1.2-1-1.6-1.4c-0.2-0.6,0.9-0.2,0.7-0.9 c-0.2-0.6-1.9-1.8-2.2-2.3c-1.1-1.2,1,0.4,2.3,1.4c-0.2-0.5,0.8,0.7,1,0.5c0.3-0.4,0.7-0.8-0.7-2.4c-0.3-0.4,0.3-0.4,0.5-0.6 c-2.5-2.1-5.1-4.2-7.9-6.2c-0.7-0.5-1.4-1-2.1-1.4c-0.7-0.5-1.4-0.9-2.3-1.5c-0.2-0.1-0.5-0.3-0.7-0.4C10,1.3,9.9,1.2,9.7,1.1 C9.6,1,9.5,0.9,9.4,1C9.3,1,9.2,0.9,9.1,0.9C8.4,0.6,7.7,0.5,7.1,0.4C5.7,0.3-0.4,7.3,0,8.3c0.5,1.1,0,1.3,0.7,2.2 c0.6,0.8,5.2,4.2,5.8,4.8c0,0.1,0,0.1,0,0.2c2.3,2.5,7,6,9.7,8.1c0.2,0,0.3-0.2,0.5-0.4c-0.3-0.3-0.7-0.4-0.7-0.8 c-0.1-0.1,0.4-0.3,0.5-0.5c-0.1-0.1-2.6-2.2-2.7-2.3c0.2-0.3,1.2,0,1.4-0.3c0.2-0.3-0.3-0.4-0.2-0.7c0-0.4,1.6,0.8,1.8,1 c0.1-0.2,0.1,0.1,0.3-0.1c0.2-0.2,0.4-0.4,0.5-0.7c1.2,0.9,2,1.6,3.2,2.5c0.3,0.1,0.4-0.2,0.5-0.4c-0.5-0.4-2.2-1.7-2.4-2.2 c-0.1-0.1,0.4-0.3,0.5-0.6c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-0.4,0.6-0.5,0.7-0.8c0.1-0.4-0.5-0.6-0.4-0.9c-0.2-0.5,0.5-0.1,0.8,0.2 c0.1-0.3,0.2,0.2,0.4,0c0,0,0.1-0.1,0.1-0.1c1.8,1.5,2.3,1.9,4.1,3.4C25.9,20.7,25.7,20.1,25.8,19.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoundary);
export default __webpack_public_path__ + "static/media/Boundary.d409f86389e0d21171b609aede7feb86.svg";
export { ForwardRef as ReactComponent };